/*
 When use custom analytics is called, 
 it will track page, location will be 
 tracked under hero_location for all calls that use track()
*/

import { getAnonymousId } from './get-anonymous-id';

export const serverIdentify = async (data) => {
  const { email, firstName, lastName, dateOfBirth, locationDetail, locationHero } = data;

  const id = getAnonymousId();

  if (!email) throw new Error('Missing fields');
  try {
    const response = await fetch('/.netlify/functions/backend-data-collection/', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      // Not recommended to send email as anonymous or user id but, user id is not set in brave browser
      body: JSON.stringify({
        anonymousId: id ?? email,
        email,
        firstName,
        lastName,
        dateOfBirth,
        locationDetail,
        locationHero,
      }),
    });
    const responseJson = await response.json();
    if (!response.ok) {
      throw new Error('Server Identify failed', responseJson?.message);
    }
  } catch (error) {
    throw error;
  }
};
